import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import LoadingContextProvider from './contexts/LoadingContext';
import App from './App';
import './assets/styles/reset.css';
import './assets/styles/global.css';
import ContentContextProvider from './contexts/ContentContext';
import { ErrorBoundary } from './components/ErrorBoundry/ErrorBoundry';
import LocationContextProvider from './contexts/LocationContext';

const root = createRoot(document.getElementById('root'));
root.render(
    <ContentContextProvider>
        <LoadingContextProvider>
            <Router>
                <ErrorBoundary>
                    <Suspense fallback={<div />}>
                        <LocationContextProvider>
                            <App />
                        </LocationContextProvider>
                    </Suspense>
                </ErrorBoundary>
            </Router>
        </LoadingContextProvider>
    </ContentContextProvider>
);
